/* RESPONSIBLE TEAM: team-automation-foundations */
import type Transition from '@ember/routing/transition';
import FinAIAgentTasksIndexRoute from 'embercom/routes/apps/app/automation/fin-ai-agent/tasks/index';

export default class FinAiAgentEcommerceTasksIndexRoute extends FinAIAgentTasksIndexRoute {
  analytics = {
    section: 'automation',
    place: 'fin-ai-agent.ecommerce.tasks',
  };

  async beforeModel(transition: Transition) {
    if (this.appService.app.canUseFinProcedures) {
      this.router.transitionTo('apps.app.automation.fin-ai-agent.ecommerce.procedures', {
        queryParams: transition.to?.queryParams || {},
      });
      return;
    }

    await super.beforeModel(transition);
  }
}
